import React from 'react'

import htmr from 'htmr'
import PropTypes from 'prop-types'

import shortcodeParser from '../../utils/filters/shortcodeParser'

const Footnote = ({ content, className }) => <sup className={className}>{htmr(shortcodeParser(content))}</sup>

Footnote.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired,
}

Footnote.defaultProps = {
  className: '',
}

export default Footnote
